var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoThinkTank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_thinktank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 75 75 75 75 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_thinktank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0617,48.8389 L43.5127,49.1159 L43.5127,53.9269 L31.5407,53.9269 L31.5407,49.1159 L30.9907,48.8389 C26.0537,46.3469 22.9877,41.3759 22.9877,35.8659 C22.9877,27.8489 29.5097,21.3269 37.5267,21.3269 C45.5427,21.3269 52.0647,27.8489 52.0647,35.8659 C52.0647,41.3759 48.9987,46.3469 44.0617,48.8389 L44.0617,48.8389 Z M41.5007,64.6349 L33.5517,64.6349 L31.5407,62.6239 L31.5407,61.1219 L43.5127,61.1219 L43.5127,62.6239 L41.5007,64.6349 Z M31.5407,59.1219 L43.5137,59.1219 L43.5137,55.9269 L31.5407,55.9269 L31.5407,59.1219 Z M37.5267,19.3269 C28.4067,19.3269 20.9877,26.7459 20.9877,35.8659 C20.9877,41.9279 24.2487,47.4159 29.5407,50.3339 L29.5407,63.4519 L32.7237,66.6349 L42.3297,66.6349 L45.5127,63.4519 L45.5127,50.3339 C50.8037,47.4159 54.0647,41.9279 54.0647,35.8659 C54.0647,26.7459 46.6457,19.3269 37.5267,19.3269 L37.5267,19.3269 Z",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "34.4279 30.3569 40.8639 32.7759 30.9429 36.5049 31.1099 38.4239 39.9349 40.0819 37.1849 41.0839 36.5269 42.0229 36.5269 48.7319 34.4369 48.7319 34.4369 50.7319 40.6159 50.7319 40.6159 48.7319 38.5269 48.7319 38.5269 42.7229 44.0479 40.7129 43.8909 38.7909 34.9939 37.1189 44.0579 33.7119 44.0579 31.8399 35.1309 28.4849"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "9.831 36.68 14.536 36.68 14.536 34.68 9.831 34.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "60.463 36.68 65.169 36.68 65.169 34.68 60.463 34.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "14.5276 51.1343 15.7036 52.7523 19.5096 49.9863 18.3346 48.3683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "60.4729 20.2256 59.2969 18.6076 55.4899 21.3726 56.6649 22.9916"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "47.0012 9.6738 45.0992 9.0558 43.6452 13.5308 45.5472 14.1498"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "31.3547 13.5312 29.9007 9.0552 27.9987 9.6742 29.4527 14.1492"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "55.4895 49.9863 59.2975 52.7523 60.4725 51.1343 56.6655 48.3683"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "14.5276 20.2256 18.3346 22.9916 19.5096 21.3726 15.7036 18.6076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThinkTank);
export default __webpack_public_path__ + "static/media/ico_think_tank.1a81cdb4fe188309d6203984f45e3fc6.svg";
export { ForwardRef as ReactComponent };